import { graphql } from '~publish/graphql'

import { SavedViewFields } from './SavedViewFields'

export const UpdateSavedViewMutation = graphql(
  /* GraphQL */ `
    mutation UpdateSavedView($input: UpdateSavedViewInput!) {
      updateSavedView(input: $input) {
        __typename
        ... on SavedView {
          ...SavedViewFields
        }
        ... on MutationError {
          message
        }
      }
    }
  `,
  [SavedViewFields],
)
